/**
 * Created by eliorc on 9/29/14.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};

    var DialogManager = function (options) {

        this.activeDialog = null;
        this.dialogs = options && options.dialogs;
        this.context = options.context;

        this.showDialog = function (dialog) {
            var targetDialog = this.dialogs[dialog];

            this.hideDialog();

            var showFunction = targetDialog.showDialog || targetDialog.viewController.showDialog || targetDialog.viewController.lpShow;

            var context = (showFunction && showFunction === targetDialog.showDialog && this.context) || targetDialog.viewController;

            var config = targetDialog.config || {};
            if (showFunction){
                showFunction.call(context, config);
            }

            // setting the active dialog
            this.activeDialog = targetDialog;
        };

        this.hideDialog = function () {
            if (this.activeDialog) {

                var hideFunction = this.activeDialog.hideDialog || this.activeDialog.viewController.hideDialog || this.activeDialog.viewController.lpHide;

                var context = (hideFunction && hideFunction === this.activeDialog.hideDialog && this.context) || this.activeDialog.viewController;

                if (hideFunction) {
                    hideFunction.call(context);
                }

                // resetting the active dialog.
                this.activeDialog = null;
            }
        };


    };


    return DialogManager;

});
